import { ProducerStore } from 'store/producer/types.ts'

export const initialProducerState: ProducerStore = {
  error: false,
  loading: false,
  latestProducerID: 0,
  uploadingImage: null,
  producers: [],
  producer: undefined,
  contracts: []
}
